import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// routes
import { withRouter } from 'react-router-dom'

// modals
import ModalDetalleVenta from './ModalDetalleVenta/ModalDetalleVenta'
import ModalDetalleMedioPago from './ModalDetalleMedioPago/ModalDetalleMedioPago'

// services
import { deleteByIdVentas } from './../../Services/ventaService'

// utils
import { formatFechaArgentina } from '../../utils/fechaArgentina'

// alert swal
import Swal from 'sweetalert2'

const ItemVenta = ({ venta, setIsLoad, readOnly = false }) => {
    const deleteVenta = (venta) => {
        Swal.fire({
            title: 'Estas seguro de eliminar?',
            text: 'Se eliminara el articulo de la sucursal!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                deleteByIdVentas(venta.id)
                    .then((res) => {
                        Swal.fire(
                            'Eliminado!',
                            'La venta fue eliminada de la sucursal.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    const estado = (estado) => {
        if (estado === 'PAGADA') return <p className="text-success">PAGADA</p>
        if (estado === 'PAGADA_PARCIALMENTE')
            return <p className="text-warning">PAGADA PARCIALMENTE</p>
        if (estado === 'ADEUDADA')
            return <p className="text-primary">ADEUDADA</p>
        if (estado === 'CANCELADA')
            return <p className="text-warning">CANCELADA</p>
    }

    const fecha = formatFechaArgentina(venta.createdAt)
    const hora = formatFechaArgentina(venta.createdAt, 'HH:mm:ss')

    return (
        <tr>
            <th scope="row">{venta.numeroComprobante}</th>
            <td>${venta.total.toFixed(2)}</td>
            <td>{estado(venta.estado)}</td>
            <td>
                {fecha} / {hora}
            </td>
            <td>{venta.sucursal.nombre}</td>
            <td>{venta.tipoComprobante.nombre}</td>
            <td>
                {venta.cliente.id.persona.apellido},{' '}
                {venta.cliente.id.persona.nombre}
            </td>
            <td>{venta.facturada ? "SI" : "NO"}</td>
            <td>{venta.facturada ? venta.numeroComprobanteAfip : "-"}</td>
            <td>
                <ModalDetalleMedioPago item={venta} />
                <ModalDetalleVenta item={venta} />
                {!readOnly ? (
                    <button
                        className="btn text-primary"
                        title="Eliminar"
                        onClick={() => {
                            deleteVenta(venta)
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} /> Eliminar
                    </button>
                ) : null}
            </td>
        </tr>
    )
}

export default withRouter(ItemVenta)
